(function () {
  'use strict';

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function initSection(section) {
    const viewport = section.querySelector('.testimonials__viewport');
    const track = section.querySelector('.testimonials__track');
    if (!viewport || !track) return;

    const slides = Array.from(track.children);
    const prevBtn = section.querySelector('[data-prev]');
    const nextBtn = section.querySelector('[data-next]');
    const dotsWrap = section.querySelector('[data-dots]');

    let index = 0;
    let timer = null;
    const autoplay = section.getAttribute('data-autoplay') === 'true';
    const delay = parseInt(section.getAttribute('data-delay') || '5000', 10);
    const layout = section.dataset.layout || 'responsive';
    const desktopSlides = parseInt(section.dataset.desktopSlides || '3', 10);
    const tabletSlides = parseInt(section.dataset.tabletSlides || '2', 10);
    const mobileSlides = parseInt(section.dataset.mobileSlides || '1', 10);

    function slidesPerView() {
      if (layout === 'single') return 1;
      const width = section.offsetWidth;
      if (window.matchMedia('(min-width: 990px)').matches) return desktopSlides;
      if (window.matchMedia('(min-width: 750px)').matches) return tabletSlides;
      return mobileSlides;
    }

    function maxIndex() {
      const spv = slidesPerView();
      return Math.max(0, slides.length - spv);
    }

    function update() {
      index = clamp(index, 0, maxIndex());
      const slideWidth = slides[0].offsetWidth + parseFloat(getComputedStyle(track).columnGap || 0);
      const x = -(slideWidth * index);
      track.style.transform = `translate3d(${x}px, 0, 0)`;

      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= maxIndex();
      if (dotsWrap) {
        const buttons = dotsWrap.querySelectorAll('button');
        buttons.forEach((b, i) => b.setAttribute('aria-selected', i === index ? 'true' : 'false'));
      }
    }

    function goTo(newIndex) {
      index = clamp(newIndex, 0, maxIndex());
      update();
    }

    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      const total = maxIndex() + 1; // one dot per position
      for (let i = 0; i < total; i += 1) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('aria-label', `Go to slide ${i + 1}`);
        btn.addEventListener('click', () => goTo(i));
        dotsWrap.appendChild(btn);
      }
    }

    function start() {
      if (!autoplay) return;
      stop();
      timer = setInterval(() => {
        if (index >= maxIndex()) {
          index = -1; // will become 0 on next()
        }
        next();
      }, delay);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    // Events
    if (nextBtn) nextBtn.addEventListener('click', next);
    if (prevBtn) prevBtn.addEventListener('click', prev);

    // pause on hover / focus within
    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', start);
    section.addEventListener('focusin', stop);
    section.addEventListener('focusout', start);

    // handle resize
    let resizeRaf = null;
    window.addEventListener('resize', () => {
      if (resizeRaf) cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(() => {
        buildDots();
        update();
      });
    });

    // setup
    buildDots();
    update();
    start();
  }

  function initAll() {
    document.querySelectorAll('.testimonials').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target.querySelector('.testimonials');
    if (el) initSection(el);
  });
})();


